import { requireNativeView } from 'expo';

export default requireNativeView('ExpoVideo', 'VideoAirPlayButtonView');
